module.exports = __webpack_public_path__ + "static/media/css.b848d5d9.png";